export const uploadCsv = {

    SEND_CSV_FILE: "SEND_CSV_FILE",
    SEND_CSV_FILE_SUCCESS: "SEND_CSV_FILE_SUCCESS",
    SEND_CSV_FILE_ERRORS: "SEND_CSV_FILE_ERRORS",

};

